import { useSearchParams } from "react-router-dom"
import { Footer } from "../../../Footer/Footer"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../../IndexPage/Header/Header"
import { PrinciplesDiagram } from "./PrinciplesDiagram"
export const Services = (BtnShow) => {
    return (
        <>
         <div className="container-fluid">
            <div className="row" >
                <div className="col-12">
                    <Header actives="Services" />
                    <HerosectionsAll ScreenName="Principles of Insurance" ScreenSearch="PrinciplesofInsurance" />
                    {/* <Principles SubName='Principles of Insurance' /> */}
                    <PrinciplesDiagram/>
                    <Footer />
                </div>
            </div>
            </div>
        </>
    )
}
